import { Sparkles, AlignVerticalDistributeCenter, HeartPulse } from "lucide-react";

const TREATMENTS = [
  {
    icon: Sparkles,
    title: "Implantodontia",
    intro:
      "Solução moderna para substituir dentes perdidos com segurança, conforto, estética e funcionalidade.",
    benefits: [
      "Recuperação da mastigação",
      "Melhora da estética facial",
      "Preservação óssea",
      "Maior autoestima",
      "Resultado duradouro",
    ],
  },
  {
    icon: AlignVerticalDistributeCenter,
    title: "Ortodontia",
    intro:
      "Tratamentos voltados para alinhamento dentário e correção da mordida.",
    benefits: [
      "Dentes tortos",
      "Espaçamentos",
      "Mordida cruzada",
      "Mordida aberta",
      "Problemas funcionais",
    ],
  },
  {
    icon: HeartPulse,
    title: "Endodontia",
    intro:
      "Tratamento especializado para preservação de dentes comprometidos por cáries profundas, traumas ou infecções.",
    benefits: [
      "Eliminar dor",
      "Combater infecções",
      "Preservar dentes naturais",
      "Evitar extrações desnecessárias",
    ],
  },
];

export const Treatments = () => {
  return (
    <section
      id="tratamentos"
      data-testid="treatments-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-xs tracking-[0.32em] uppercase text-[#D4AF37]">
              Tratamentos Odontológicos
            </span>
          </div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
            Atuação clínica{" "}
            <span className="italic text-[#D4AF37]">especializada</span>.
          </h2>
          <p className="mt-6 text-white/65 max-w-2xl leading-relaxed">
            Além da atuação pericial, o consultório oferece tratamentos
            odontológicos em áreas de alta especialização — com a mesma
            excelência técnica.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {TREATMENTS.map((t, i) => {
            const Icon = t.icon;
            return (
              <article
                key={i}
                data-testid={`treatment-card-${i}`}
                className="group relative bg-[#0a0a0a] border border-[#D4AF37]/15 hover:border-[#D4AF37]/50 p-8 lg:p-10 transition-all duration-500 hover:-translate-y-1"
              >
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 border border-[#D4AF37]/40 flex items-center justify-center group-hover:bg-[#D4AF37]/10 transition-colors">
                    <Icon
                      size={22}
                      strokeWidth={1.4}
                      className="text-[#D4AF37]"
                    />
                  </div>
                  <h3 className="font-serif-display text-2xl text-white">
                    {t.title}
                  </h3>
                </div>

                <p className="text-sm text-white/65 leading-relaxed mb-6">
                  {t.intro}
                </p>

                <div className="pt-6 border-t border-[#D4AF37]/15">
                  <div className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]/80 mb-4">
                    Principais Benefícios
                  </div>
                  <ul className="space-y-2.5">
                    {t.benefits.map((b, j) => (
                      <li
                        key={j}
                        className="flex items-start gap-3 text-sm text-white/75"
                      >
                        <span className="mt-2 h-px w-3 bg-[#D4AF37] shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
